import { gsap } from "gsap";
import { isDesktop } from '../components/exportFunc'
export default ()=>{
    const playButtons = document.querySelectorAll('[team-element]');

    playButtons.length >0 && isDesktop()?showInfo():false;
    function showInfo(){
        playButtons.forEach(el =>{
            const button = el.querySelector('[hover-state]');
            const info = el.querySelector('.info');
            button.addEventListener('mouseover', ()=>{
                gsap.to(info, {
                    height: 'auto',
                    duration: 0.5,
                    ease: 'Power3.inOut'
                })
            })
            el.addEventListener('mouseleave', ()=>{
                gsap.to(info, {
                    height: 0,
                    duration: 0.5,
                    ease: 'Power3.inOut'
                })
            })
        })
    }
}